import Logout from "@mui/icons-material/Logout";
import Settings from "@mui/icons-material/Settings";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import * as React from "react";
import { useNavigate } from "react-router-dom";

export default function UserProfileDropdown() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  var navigate = useNavigate();
  const handleClose = () => {
    setAnchorEl(null);
  };
 const userName = localStorage.getItem("userEmail");
 const firstLetter = userName ? userName.charAt(0).toUpperCase() : "";

 return (
   <React.Fragment>
     <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
       <Tooltip title="Account settings">
         <IconButton
           onClick={handleClick}
           size="small"
           sx={{ ml: 2 }}
           aria-controls={open ? "account-menu" : undefined}
           aria-haspopup="true"
           aria-expanded={open ? "true" : undefined}
         >
           <Avatar sx={{ width: 32, height: 32 }}> {firstLetter}</Avatar>
         </IconButton>
       </Tooltip>
     </Box>
     <Menu
       anchorEl={anchorEl}
       id="account-menu"
       open={open}
       onClose={handleClose}
       onClick={handleClose}
       PaperProps={{
         elevation: 0,
         sx: {
           overflow: "visible",
           filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
           mt: 1.5,
           "& .MuiAvatar-root": {
             width: 32,
             height: 32,
             ml: -0.5,
             mr: 1,
           },
           "&:before": {
             content: '""',
             display: "block",
             position: "absolute",
             top: 0,
             right: 14,
             width: 10,
             height: 10,
             bgcolor: "background.paper",
             transform: "translateY(-50%) rotate(45deg)",
             zIndex: 0,
           },
         },
       }}
       transformOrigin={{ horizontal: "right", vertical: "top" }}
       anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
     >
       <MenuItem>
         {" "}
         <span>{userName}</span>
       </MenuItem>

       <MenuItem onClick={handleClose}>
         <Avatar /> Profile
       </MenuItem>

       <Divider style={{ width: "200px" }} />
       <MenuItem onClick={handleClose}>
         <ListItemIcon>
           <Settings fontSize="small" />
         </ListItemIcon>
         Settings
       </MenuItem>
       <MenuItem
         onClick={() => {
           handleClose();
           localStorage.clear();
           navigate("/");
         }}
       >
         <ListItemIcon>
           <Logout fontSize="small" />
         </ListItemIcon>
         Logout
       </MenuItem>
     </Menu>
   </React.Fragment>
 );
}
